export const decode_utf8 = (str: string): string => {
    try {
        return decodeURIComponent(escape(str))
    } catch (error) {
        return JSON.stringify({})
    }
}
